import React from 'react';
import constants from 'constants';

const {
} = constants;

function Tools({
                 count
               }) {
  return (
    <div className="admin_list">
      <div className="admin_list_users">
        <h5>Approve Users (<span>{count}</span>)</h5>
      </div>

    </div>

  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;





// WEBPACK FOOTER //
// ./src/components/Admin/ApproveDiscipline/Toolbar/Tools.jsx